import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fleet-tip-modal',
  templateUrl: './fleet-tip-modal.component.html',
  styleUrls: ['./fleet-tip-modal.component.scss'],
})
export class FleetTipModalComponent {
  constructor(
    private dialogRef: MatDialogRef<FleetTipModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  close() {
    this.dialogRef.close();
  }
}
